var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('u-header',{attrs:{"title":_vm.$t('_.security_settings')}}),_vm._v(" "),_c('client-login',{attrs:{"client-id":_vm.clientId,"is-collapse":false}}),_vm._v(" "),_c('client-2fa-contextualise')],1)}
var staticRenderFns = []

export { render, staticRenderFns }